exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colors[data-v-a23dad7a]{color:black}.whishlist-count[data-v-a23dad7a]{top:1px;left:22px;min-width:16px;min-height:16px;border-radius:10px}\n", ""]);

// exports
